import { Grid, useMediaQuery } from '@mui/material';
import React, { useState } from 'react'
import textStyles from "../../../../../assets/styles/componentStyles/manychatStyles/instagramStepComponent.module.scss"
import styles from '../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss'
import globalStyles from "../../../../../assets/styles/global.module.scss";
import workflowStyles from "../../../../../assets/styles/componentStyles/workflowStyles/workflowStyle.module.scss";
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import GlobalPopUp from '../../../../utility/globalPopUp';
import SendMediaPopup from './sendMedia/sendMediaPopup';
import { toCapitalizedCase } from '../../../../../utils/constants';
import { getMediaFileDescription } from '../../flowBuilderConstants';

const SendMediaComponent = (props: any) => {
    
    const { actionData, stepAction } = props;
    const flagSmallScreen = useMediaQuery<boolean>('(min-width: 0px) and (max-width: 900px)'); 

    const [flagSendMediaPopup, setFlagSendMediaPopup] = useState<boolean>(false);

    return (
        <>
            <Grid item>
                <Grid container direction={"column"} gap={"12px"}>
                    <Grid item mt={2} className={textStyles.templatesContainer}>
                        <Grid container direction={"column"} gap={"8px"} flexWrap={"nowrap"}>
                            <Grid item className={`${styles.bodyFormHeadingStyle} ${globalStyles.primaryFontSize} ${globalStyles.primaryFontWeight}`}>
                                {getMediaFileDescription(stepAction?.flag_saved_in_BE, actionData, "left section")?.title}
                            </Grid>
                            <Grid item className={`${styles.contentBlockSubHeadingStyle} ${workflowStyles.resetVariableText}`}>
                                <Grid container gap={1} justifyContent={"space-between"} flexWrap={"nowrap"} alignItems={"center"}>
                                    <Grid item className={globalStyles.wordBreakBreakWord}>
                                        {getMediaFileDescription(stepAction?.flag_saved_in_BE, actionData, "left section")?.description}
                                    </Grid>
                                    <Grid item>
                                        <ModeEditIcon className={styles.editActionIcon} onClick={() => setFlagSendMediaPopup(true)} />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                {flagSendMediaPopup &&
                    <GlobalPopUp
                        open={flagSendMediaPopup}
                        onClose={() =>  {setFlagSendMediaPopup(false);}}
                        flagBackdrop
                        paperMinWidth={flagSmallScreen ? "280px" : "850px"}
                        paperMaxwidth={flagSmallScreen ? "380px" : "850px"}
                        flagShowCloseIcon={true}
                        // height={"100%"}
                        titlePadding='0'
                        handleClose={() => { setFlagSendMediaPopup(false); }}
                    >
                        <SendMediaPopup actionData={actionData} stepAction={stepAction} setFlagSendMediaPopup={setFlagSendMediaPopup} />
                    </GlobalPopUp>
                }
            </Grid>
        </>
    )
}

export default SendMediaComponent
